module.exports = __webpack_public_path__ + "static/media/Beach4.9fcfe763.jpg";